import React, {useState} from 'react';
import _ from 'lodash';
import TransitionExpand from './TransitionExpand';
import classes from './index.css';

export default function ActivityCompDetails(props){
    const getRelatedActivities = () => {
        var compid=props.competency.id
        var relatedActivities={}
        Object.keys(props.activities).forEach(actid => {
            var activity=props.activities[actid].activity
            if (props.activities[actid].competencies.filter(idx => idx == compid).length){
                relatedActivities[actid]={
                    name: activity.itemname,
                    id: actid
                }
            }
        })
        return relatedActivities
    }

    const getRelatedModules = () => {
        let rMods={};
        Object.keys(props.compMods.module).forEach(cmid =>{
            let modname=props.compMods.module[cmid].cm_info.name
            rMods[cmid]={
                name: modname,
                id: cmid
            }
        })
        return rMods
    }

    const checkFilter = (comp) =>{
        if(props.keywords.length){
            let regexp=new RegExp(props.keywords.replaceAll(' ', '|'), "i")
            if(regexp.test(`${comp.idnumber} ${comp.description}`)){
                return true
            } else {
                return false
            }
        }
        return true
    }

    var relatedModules=getRelatedModules();
    var relatedActivities=getRelatedActivities();

    var compBtnPressed = props.showDetails || props.expandAll ? classes.btnPressed : classes.btnNotPressed; 

    return(
        <>
        {Object.keys(relatedModules).length > 0 && checkFilter(props.competency) && (
            <div className={classes.activityCompDetail}>
                <div className={classes.compBtn + ' ' + classes.btnCompActivity + ' ' + compBtnPressed}
                    title={props.competency.description}
                    onClick={props.toggleShowCompActivities}> {/*may need to be arrow func */}
                        <h5>
                            <strong>
                                {props.competency.idnumber + " "}
                            </strong>
                            <span className={classes.moduleCount}>
                                {Object.keys(relatedModules).length}
                            </span>
                        </h5>
                        {!(props.showDetails || props.expandAll )&& (
                            <p>
                                {props.competency.description}
                            </p>
                        )}
                    </div>
                    <TransitionExpand duration={500} height={(props.showDetails || props.expandAll) ? 'auto' : 0}>
                        {(props.showDetails || props.expandAll) && (
                            <div className={classes.compActivityDetails}>
                                <p>{props.competency.description}</p>
                                {Object.keys(relatedModules).map((rmid, kee) => {
                                    var activity = relatedModules[rmid];
                                    return(
                                        <div className={classes.activitybox}
                                            key={kee}
                                        >
                                            {activity.name}
                                        </div>
                                    ) 
                                })}
                            </div>
                        )}
                    </TransitionExpand>
            </div>
        )}
        </>
        
    )
}